export default {
  methods: {
    showPopup(popupComponentName) {
      // open popup by name of component
      this.$store.commit('showPopup', popupComponentName);
    },
    hidePopup() {
      this.$store.commit('hidePopup');
    }
  }
};
